import React from 'react';
import styled from 'styled-components'



const ImageInputBtn = ({btnLabel,handleOnChange}) => {
  return (
    <UploadBtn className="file-input">
    <input
      type="file"
      name="fileInput"
      id="file-input"
      accept='image/*'
      className="file-input__input"
      onChange={handleOnChange}
    />
    <label className="file-input__label" htmlFor="file-input">
      <span>{btnLabel}</span>
      </label>
  </UploadBtn>
  )
};

export default ImageInputBtn;

const UploadBtn  = styled.div`
    .file-input__input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.file-input__label {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: #fff;
  background-color: ${({theme}) => theme.accent};
  padding: 0.8rem 1rem;
  max-height: 3rem;
  width: fit-content;
  max-width: fit-content;
  font-size: 0.8rem;
  font-family: Montserrat;
  font-weight: 600;
  cursor: pointer;

}



`